import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate} from "react-router-dom";
import {Divider, message, Modal, Space, Spin, Tag, Typography} from "antd";
import {FormUtils} from "../../../utils/FormUtils";
import {SystemApi} from "../../../services/SystemApi";

const FORM = [
    {
        name: "授权名称",
        key: "name",
        type: "input",
        required: true
    },
    {
        name: "当前账户密码",
        key: "password",
        type: "password",
        required: true,
        extra: <Tag color="red">需要重新输入当前用户密码来进行敏感操作</Tag>
    },
]

const SystemAuthEditPage = () => {
    const navigator = useNavigate()

    const [loading, setLoading] = useState(false)

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {

    }, []);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        return SystemApi.newAuth(form.name, form.password)
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false)
            // 因为API的更新和新建合并在一起了，需要初始化表单来补充没有变更的数据
            const submitData = {
                ...form
            }

            if (!submitData.name) {
                message.error("请输入名称")
                return false;
            }

            if (!submitData.password) {
                message.error("请输入密码")
                return false;
            }

            setLoading(true)

            createOrUpdate(submitData)
                .onSuccess(data => {
                    Modal.success({
                        content: <>
                            <Space wrap>
                                APP KEY：
                                <Typography.Paragraph strong copyable={{tooltips: false}} style={{wordBreak: 'break-all'}}>{data.appKey}</Typography.Paragraph>
                            </Space>
                            <Space wrap>
                                APP SECRET:
                                <Typography.Paragraph
                                    strong
                                    copyable={{tooltips: false}} style={{wordBreak: 'break-all'}}>{data.appSecret}</Typography.Paragraph>
                            </Space>
                            <Divider/>
                            <Tag color="red">App Secret 只会显示这一次，复制后妥善保存。</Tag>
                        </>,
                        onOk() {
                            navigator('/system/auth', {replace: true})
                        },
                    })
                })
                .onComplete(() => {
                    setLoading(false)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <Spin spinning={loading}>
                <AutoFormCard
                    title={"编辑系统属性"}
                    formStruct={FORM}
                    loading={false}
                    onClickCancel={e => {
                        navigator(-1)
                    }}
                    onClickSubmit={handleFormSubmit}
                    onFormChange={handleFormChange}
                />
            </Spin>
        </>
    )
}

export default SystemAuthEditPage